import React from 'react';
import { connect } from 'react-redux';

import { Button } from 'apps/auth/components/common/Button/Button';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { MainColumn } from 'apps/auth/components/common/Layout/MainColumn/MainColumn';
import { BlockSubheader, FeaturesBlock, FeaturesList, FeaturesListItem, IntroBlock, IntroBlockImg } from 'apps/auth/components/common/Layout/MainColumn/styles';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Text } from 'apps/auth/components/common/Text/Text';
import Notification from 'apps/auth/components/history/Notification';
import { amplitudeEventForGetCardFromCards } from 'apps/auth/components/utils/AmplitudeUtils';
import { AUTH_GA_VIRTUAL_CARD_CREATE_PREVIEW, URL_IMAGES_I } from 'apps/auth/constants/UrlConstants';
import { useThemeDetector } from 'apps/auth/hooks/theme';

const EmptyCardsGA = (props) => {
    let featuresArray = [props.featuresTitleSection1, props.featuresTitleSection2, props.featuresTitleSection3];

    const { theme } = useThemeDetector();

    let featuresList = (
        <FeaturesList>
            {featuresArray.map((item, i) => (
                <FeaturesListItem key={item + i}>
                    <Icon name="check" color="primary" rightIndent="16px" />
                    <span>{item}</span>
                </FeaturesListItem>
            ))}
        </FeaturesList>
    );

    return (
        <MainColumn>
            <Notification />
            <IntroBlock>
                <IntroBlockImg>
                    <img src={`${URL_IMAGES_I}/empty-card-mastercard${theme === 'dark' ? '-dark' : '-light'}.svg`} alt="empty-card-mastercard" />
                </IntroBlockImg>
                <Text size={'main'}>{props.OpenAccountAndCard}</Text>
            </IntroBlock>
            <Separator />
            <FeaturesBlock>
                <BlockSubheader>{props.featuresTitle}</BlockSubheader>
                {featuresList}
            </FeaturesBlock>
            <FixedBottomPanel fullwidth isPressedAboveMenu isRightAligned>
                <Button
                    type="link"
                    raised={true}
                    href={AUTH_GA_VIRTUAL_CARD_CREATE_PREVIEW}
                    caption={props.getCard}
                    onClick={() => {
                        amplitudeEventForGetCardFromCards();
                    }}
                />
            </FixedBottomPanel>
        </MainColumn>
    );
};

const mapStateToProps = (state) => {
    return {
        getCard: state.messages.pageMessages.getCard,
        OpenAccountAndCard: state.messages.pageMessages.OpenAccountAndCard,
        featuresTitle: state.messages.pageMessages.featuresTitle,
        featuresTitleSection1: state.messages.pageMessages.featuresTitleSection1,
        featuresTitleSection2: state.messages.pageMessages.featuresTitleSection2,
        featuresTitleSection3: state.messages.pageMessages.featuresTitleSection3,
    };
};
export default connect(mapStateToProps)(EmptyCardsGA);
